import React from 'react';
import {useHistory} from "react-router-dom";
import '../../assets/vendor/bootstrap/css/bootstrap.min.css';
import '../../assets/vendor/icofont/icofont.min.css';
import '../../assets/vendor/boxicons/css/boxicons.min.css';
import '../../assets/vendor/font-awesome/css/font-awesome.min.css';
import '../../assets/vendor/remixicon/remixicon.css';
import '../../assets/vendor/venobox/venobox.css';
// import '../assets/vendor/owl.carousel/assets/owl.carousel.min.css';
import '../../assets/vendor/aos/aos.css';
import "../../assets/vendor/slick/css/slick.min.css";

import '../Footer/Footer.css';
import '../../assets/css/responsive.css';

const Footer = () => {
   const history = useHistory();
    return (
        <div>
        <footer id="footer">
        <div class="container-fluid footer-bottom clearfix">
          <div class="copyright">© Copyright 2021 Ur2nd Lot<sup>TM</sup>. All Rights Reserved</div>
          <div class="bottomLinks"><a href="" onClick={()=>history.push('/privacypolicy')}>Privacy Policy </a>| <a href="">Terms of Use</a></div>
        </div>
      </footer>
            <script src="assets/js/jquery.min.js"></script>
            <script src="vendor/owl-carousel/js/owl.carousel.min.js"></script>
            <script src="vendor/wow-js/js/wow.min.js"></script>
            <script src="vendor/wow-js/js/custom.js"></script>
            <script src="vendor/bootstrap/js/bootstrap.min.js"></script>
        </div >
    );
}


export default Footer